var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/savenavigationmodel',["require", "exports", "common/parts", "areas/navigationmanager/services/navigationrepository"], function (require, exports, Parts, Repository) {
    "use strict";
    var SaveNavigationModel = (function (_super) {
        __extends(SaveNavigationModel, _super);
        function SaveNavigationModel(taskManager) {
            _super.call(this);
            this._taskManager = taskManager;
        }
        SaveNavigationModel.prototype.process = function (symbol) {
            var _this = this;
            try {
                var repository = new Repository.NavigationRepository();
                this.applyCurrentValues(symbol.model);
                this._taskManager.startAsync("Navigation wird gespeichert...", function () {
                    return repository.updateAsync(symbol.raw)
                        .then(function (result) {
                        _this.output.call({});
                    })
                        .fail(function (exception) {
                        _this.error.call(exception);
                    });
                });
            }
            catch (error) {
                this.error.call(error);
            }
        };
        SaveNavigationModel.prototype.applyCurrentValues = function (node) {
            var _this = this;
            node.raw.data.type = node.type;
            node.raw.data.name = node.name;
            node.raw.data.icon = node.icon;
            node.raw.data.color = node.color;
            node.raw.data.openInDialog = node.openInDialog;
            node.raw.data.openLinkInCurrentTab = node.openLinkInCurrentTab;
            node.raw.data.disableNavigateToFirstChild = node.disableNavigateToFirstChild;
            node.raw.data.key = node.key;
            node.raw.data.showOnMobile = node.showOnMobile;
            node.raw.data.useImage = node.useImage;
            node.raw.data.imagePath = node.imagePath;
            node.raw.data.defaultData = node.defaultData;
            node.raw.data.imagePathSearchbar = node.imagePathSearchbar;
            node.raw.data.permissionId = node.permissionId;
            node.raw.data.groupId = node.groupId;
            node.raw.data.template = node.template;
            node.raw.data.datakey = node.datakey;
            node.raw.data.index = node.index;
            node.raw.groups = node.groups;
            if (node.type === "Sachgebiet") {
                node.raw.data.dependsOn = node.dependsOn;
            }
            if (node.type === "Application") {
                node.raw.data.uID = node.shopId;
            }
            if (node.type === "ApplicationLink") {
                node.raw.data.route = node.route;
            }
            Enumerable.From(node.children)
                .OrderBy(function (x) { return x.index; })
                .ForEach(function (x) {
                _this.applyCurrentValues(x);
            });
        };
        return SaveNavigationModel;
    }(Parts.Part));
    return SaveNavigationModel;
});

